import app from '../main';
import { getDomain } from '../api/api';

export const userAgent = () => {
  return navigator.userAgent;
};

export const isPc = () => {
  return !/Mobi|Android|iPhone/i.test(navigator.userAgent);
};

export const getBrowserType = () => {
  let ua = userAgent().toLowerCase();
  console.log(ua);
  if(ua.indexOf('wxwork') >= 0){
    return -1;
  }else if(ua.indexOf('micromessenger') >= 0){
    if(window.__wxjs_environment === 'miniprogram'){
      return 1;
    }
    return 2;
  }else if(ua.match(/(iphone\sos)\s([\d_]+)/) || ua.match(/(ipad).*os\s([\d_]+)/)){
    return 3;
  }else{
    return 0;
  }
};

export const downloadFile = (url,back,type) => {
  if(getBrowserType()===1){
    app.$wx.miniProgram.redirectTo({url: '/pages/index/download?url='+encodeURIComponent(url)+'&back='+encodeURIComponent(back)+'&type='+type})
  }else{
    let a = document.createElement("a");
    a.target = '_blank';
    a.href = url;
    a.click();
  }
};

export const expDays = (timestamp,days=3) => {
  let now = parseInt(new Date().valueOf()/1000);
  let exptime = now - timestamp;
  if(exptime > 86400 * days){
    return Math.floor(exptime / 86400);
  }
  return 0;
};

export const getNearestHour = (timestamp,type) => {
  let timestamps = parseInt(timestamp / 1000);
  let pad = timestamps % 3600;
  if(type===1){
    return (timestamps - pad) * 1000;
  }else if(type===2){
    return (timestamps + (3600 - pad)) * 1000;
  }else{
    return (timestamps - (pad/3600 >= 0.5 ? (pad - 3600) : pad)) * 1000;
  }
};

export const formatDateTime = (date,fmt) => {
  if(!fmt) fmt = 'yyyy-MM-dd HH:mm:ss';
  if(date instanceof Number) date = new Date(date);
  let o = {
    "M+" :  date.getMonth()+1,  // 月份         
    "d+" :  date.getDate(),  // 日         
    "h+" :  date.getHours()%12 == 0 ? 12 :  date.getHours()%12,  // 小时         
    "H+" :  date.getHours(),  // 小时         
    "m+" :  date.getMinutes(),  // 分         
    "s+" :  date.getSeconds(),  // 秒         
    "q+" : Math.floor(( date.getMonth()+3)/3), //季度         
    "S" :  date.getMilliseconds()  // 毫秒         
  };
  let week = {
    "0" : "/u65e5",
    "1" : "/u4e00",
    "2" : "/u4e8c",
    "3" : "/u4e09",
    "4" : "/u56db",
    "5" : "/u4e94",
    "6" : "/u516d"
  };
  if(/(y+)/.test(fmt)){
    fmt=fmt.replace(RegExp.$1, ( date.getFullYear()+"").substr(4 - RegExp.$1.length));
  }
  if(/(E+)/.test(fmt)){
    fmt=fmt.replace(RegExp.$1, ((RegExp.$1.length>1) ? (RegExp.$1.length>2 ? "/u661f/u671f" : "/u5468") : "")+week[ date.getDay()+""]);
  }
  for( var k  in o){
    if( new RegExp("("+ k +")").test(fmt)){
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    }
  }
  return fmt;
};

export const parseVesselDataForECharts = (ols) => {
  let start = getNearestHour(ols[0],1);
  let end = getNearestHour(ols[ols.length-1],2);
  let x = [];
  let g = [];
  let y = [];
  let r = [];
  let s = [];
  let tmptime = start;
  if(ols!=null && ols.length > 0){
    for(let o = 0;o<ols.length;o++){
      let nt = getNearestHour(ols[o]['utc']*1000,1);
      let datestr = formatDateTime(new Date(nt),'yyyy-MM-dd HH')
      if(nt === tmptime){
        x.push(datestr);
        g.push([datestr,2]);
        r.push([datestr,0]);
        y.push([datestr,0]);
        s.push([datestr,Math.round(ols[o]['sog']/51.444)/10]);
        tmptime = getNearestHour(ols[o]['utc']*1000,2);
      }else{
        let flag = nt - tmptime > 86400000 ? 3 : (nt - tmptime > 7200000 ? 2 : 1) ;
        for(;tmptime<nt;tmptime+=3600000){
          let dstr = formatDateTime(new Date(tmptime),'yyyy-MM-dd HH');
          x.push(dstr);
          if(flag === 3){
            g.push([dstr,0]);
            y.push([dstr,0]);
            r.push([dstr,2])
          }else if(flag === 2){
            g.push([dstr,0]);
            y.push([dstr,2]);
            r.push([dstr,0])
          }else{
            g.push([dstr,2]);
            y.push([dstr,0]);
            r.push([dstr,0])
          }
        }
        tmptime = nt;
        x.push(datestr);
        g.push([datestr,2]);
        y.push([datestr,0]);
        r.push([datestr,0]);
        s.push([datestr,Math.round(ols[o]['sog']/51.444)/10])
      }
      if(o===ols.length-1){
        var tt = getNearestHour(ols[o]['utc']*1000,1);
        if(end > tt){
          var tflag = end - tt > 86400000 ? 3 : (end - tt > 7200000 ? 2 : 1) ;
          for(;tt < end;tt += 3600000){
            var dtstr = formatDateTime(new Date(tt),'yyyy-MM-dd HH');
            if(tflag === 3){
              g.push([dtstr,0]);
              y.push([dtstr,0]);
              r.push([dtstr,2])
            }else if(tflag === 2){
              g.push([dtstr,0]);
              y.push([dtstr,2]);
              r.push([dtstr,0])
            }else{
              g.push([dtstr,2]);
              y.push([dtstr,0]);
              r.push([dtstr,0])
            }
          }
        }
      }
    }
  }
  return {g:g,y:y,r:r,s:s};
};

export const parseVesselEchartsOptions = (chartData,options,days) => {
  chartData['xAxis']['data'] = options['x'];
  chartData['series'][0]['data'] = options['s'];
  chartData['series'][1]['data'] = options['g'];
  chartData['series'][2]['data'] = options['y'];
  chartData['series'][3]['data'] = options['r'];
  chartData['xAxis']['splitNumber'] = 24 * days;
  chartData['xAxis']['axisLabel'] = {
    formatter: (value,index)=>{
      if(value % (86400000 * Math.ceil(days/7)) == 0){
        return formatDateTime(new Date(value),'MM-dd')+"\r\n"+formatDateTime(new Date(value),'yyyy')
      }
      return '';
    }
  };
  return chartData;
};


export const parseArrayValueByObjectKeyToString = (arr,obj,sep) => {
  if(!sep) sep = ','
  let res = '';
  for(let o in obj){
    if(arr.indexOf(o)>=0){
      res += obj[o] + ',';
    }
  }
  if(res && res!=='') res = res.substr(0,res.length-1)
  return res
};

export const concatArrayValueToString = (arr,sep) => {
  if(!sep) sep = ',';
  let res = '';
  for(let a in arr){
    res += arr[a] + ','
  }
  if(res && res!=='') res = res.substr(0,res.length-1)
  return res
};

export const concatArrayKeyToString = (arr,sep) => {
  if(!sep) sep = ',';
  let res = '';
  for(let a in arr){
    res += a + ','
  }
  if(res && res!=='') res = res.substr(0,res.length-1)
  return res
};



// WEBPACK FOOTER //
// ./src/util/common.js